import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { LoginFooterData } from './modals/login-footer.interface';

@Component({
  selector: 'idp-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.scss']
})
export class LoginFooterComponent implements OnInit, OnChanges {
  @Input() loginFooterData!: LoginFooterData;
  @Input() checkOutWarmState!: boolean;
  @Input() recognitionMode!: boolean;
  @Input() isCcrLoggedOut = false;
  @Input() toggleModalCallback!: () => void;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() redirectTracking: EventEmitter<string> = new EventEmitter<string>();

  @Output() logOut = new EventEmitter();
  label = '';
  joinSkyMiles = 'joinSkyMiles';

  ngOnInit(): void {
    this.setLabel();
  }

  setLabel(): void {
    this.label = this.loginFooterData?.joinSkyMilesText;
    this.continueAsGuestLabel();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.guestMode ||
      changes.recognitionMode ||
      changes.isCcrLoggedOut
    ) {
      this.setLabel();
    }
  }

  continueAsGuestLabel() {
    if (this.checkContinueAsGuest()) {
      this.label = this.loginFooterData.continueAsGuestText;
    }
  }

  checkContinueAsGuest(): boolean {
    return (
      (this.isCcrLoggedOut || this.recognitionMode) &&
      !!this.loginFooterData.continueAsGuestText
    );
  }

  action() {
    this.redirectTracking.emit(this.joinSkyMiles);
    if (this.recognitionMode) {
      this.onCloseModal();
    } else if (this.isCcrLoggedOut) {
      this.returnToCcrPage();
    } else {
      this.onClickSkyMiles();
    }
  }

  returnToCcrPage(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const refreshURL = urlParams.get('refreshURL');

    const url = new URL(refreshURL);
    urlParams.forEach((value, key) => {
      if (key !== 'refreshURL') {
        url.searchParams.append(key, value);
      }
    });

    if (refreshURL) {
      window.location.href =
        window.location.hostname === url.hostname
          ? decodeURIComponent(url.href)
          : '/';
    } else {
      window.location.href = '/';
    }
  }

  setCustomClass(): string {
    if (this.checkOutWarmState) {
      return 'joinSkyMilesDiv--checkout-warm-state';
    }

    if (this.recognitionMode) {
      return 'joinSkyMilesDiv--continue-as-guest';
    }

    return 'joinSkyMilesDiv';
  }

  onClickSkyMiles() {
    if (this.loginFooterData && this.loginFooterData.joinSkyMilesLink) {
      window.location.href = this.loginFooterData.joinSkyMilesLink;
    }
  }

  onCloseModal() {
    this.toggleModalCallback();
  }

  displayNextView(viewName: string) {
    this.redirectTracking.emit(viewName);
    if (this.loginFooterData.accountRecoveryFlowEnabled) {
      if (viewName === this.loginFooterData.forgotLoginViewName) {
        this.nextDisplayView.emit(viewName);
      } else {
        this.nextDisplayView.emit(viewName);
      }
    } else {
      this.redirectToLoginRoute(viewName);
    }
  }

  redirectToLoginRoute(viewName: string) {
    if (viewName === this.loginFooterData.forgotLoginViewName) {
      window.location.href = this.loginFooterData.forgotLoginLink;
    } else {
      window.location.href = this.loginFooterData.forgotPasswordLink;
    }
  }

  logOutAndShopAgain() {
    this.logOut.emit();
  }
}
